var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lowerControllers',{attrs:{"gtm":_vm.gtm,"hasPreviousSlide":_vm.hasPreviousSlide,"hasNextSlide":_vm.hasNextSlide},on:{"previous":function($event){return _vm.previous()},"next":function($event){return _vm.next()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }